<template>
  <div id="statistic" class="statistic main__wrapper">
    <!-- <div class="block__back">
      <svg-icon class="icon-arrow-back" name="arrow-back" />
      <h2 class="title-h5 router-link-black">{{ $t(`modals.back`) }}</h2>
    </div> -->
    <div class="statistic__title-wrapper">
      <h2 class="title-h2 statistic__title">
        {{ $t('sections.statistic') }}
      </h2>
    </div>
    <h5 class="title-h5 statistic__subtitle">
      {{ $t('sections.states_statistic') }}
    </h5>

    <div class="statistic__main">
      <StatistictTypeTourism type="inbound" class="statistic__type-el" />
      <StatistictTypeTourism type="outbound" class="statistic__type-el" />
    </div>
  </div>
</template>

<script>
import StatisticsTable from '@/elements/StatisticsTable.vue';
import StatistictTypeTourism from '@/elements/StatistictTypeTourism.vue';
import SelectField from '@/elements/SelectField.vue';
export default {
  components: {
    StatistictTypeTourism,
    StatisticsTable,
    SelectField,
  },
  data() {
    return {};
  },

  async created() {
    await this.$store.dispatch('getContinents');
  },
};
</script>

<style lang="sass" scoped>
.statistic__title-wrapper
  display: flex
  justify-content: space-between
  margin-bottom: 2rem
  align-items: center
.statistic__subtitle
  color: $gray_notification
  margin-bottom: 6rem
  @include xs
    margin-bottom: 3rem
.statistic__details-link
  color: black
  white-space: nowrap

.statistic__type-el
  &:first-child
    margin-bottom: 7rem
    border-bottom: solid 2px $black
    padding-bottom: 40px
    @include xs
      margin-bottom: 30px
</style>
